import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { Analytics } from "@/lib/analytics";

interface ThemeToggleProps {
  size?: "default" | "sm";
}

export const ThemeToggle = ({ size = "default" }: ThemeToggleProps) => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const isSmall = size === "sm";

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => {
        const newTheme = theme === "dark" ? "light" : "dark";
        setTheme(newTheme);
        Analytics.themeChanged(newTheme);
      }}
      className={`rounded-full transition-all duration-300 hover:scale-110 ${isSmall ? "h-8 w-8" : "h-10 w-10"}`}
    >
      {theme === "dark" ? (
        <Sun className={`transition-transform duration-300 rotate-0 ${isSmall ? "h-4 w-4" : "h-5 w-5"}`} />
      ) : (
        <Moon className={`transition-transform duration-300 rotate-0 ${isSmall ? "h-4 w-4" : "h-5 w-5"}`} />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};
